import React from "react";
import PropTypes from "prop-types";
import Image from "basic-elements/Image";
import Hgroup from "public-components/Hgroup";
import Container from "public-components/Container";
import styles from "./PartnersListSection.module.scss";

const PartnersListSection = ({ data }) => {
  return (
    <section className={styles.partners}>
      <Container>
        <Hgroup className={styles.partners__hgroup} heading={data.headingH2} />
        <div className={styles.partners__list}>
          {data.homePartnersList.map(i => (
            <Image
              className={styles.partners__logo}
              key={i.id}
              data={{ width: 166, height: 40, ...i }}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

PartnersListSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    homePartnersList: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default PartnersListSection;
